import * as Consts from './Consts';

export const CorevoClient = {
    id: Consts.COREVO_CLIENT_ID,
    generalSection: {
        clientName: Consts.COREVO_CLIENT_NAME
    }
}